// extracted by css-extract-rspack-plugin
export default {"reviews":"reviews-OrgL36","reviews__title":"reviews__title-dHuO0h","reviewsTitle":"reviews__title-dHuO0h"};